import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, OutlinedInput, Typography, Stack } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import notifier from "../Notifier";
import { useHistory } from "react-router-dom";
import ApiService from "./../../services/api-service";
import * as yup from "yup";
import Loader from "../Loader";
import { useState } from "react";
import SuccessPopup from "../SuccessPopup";
import {
  getUserDetail,
  updateUserDetail,
  getErrorString,
} from "../../constants/function";
import { Formik } from "formik";
import { addSongsAction } from "../../action/songs";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DobPopup(props) {
  const { t } = useTranslation("common");
  // console.log(props);
  const [currency, setCurrecy] = React.useState("siki");
  const history = useHistory();
  const [inUsd, setInUsd] = React.useState(0);
  const [charge, setCharge] = React.useState({});
  const [amount, setAmount] = React.useState("");
  const formRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const [saveChange, setSaveChanges] = useState(false);
  let userDetail = getUserDetail();
  const schema = yup.object().shape({
    birthYear: yup.string(),
  });
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
      }
    } catch (error) {}
  };
  React.useEffect(() => {
    getChanges();
  }, []);

  const updateProfile = async (values) => {
    console.log(formRef.values);

    try {
      setLoading(true);

      const formData = new FormData();
      for (const key in formRef.current.values) {
        formData.append(key, formRef.current.values[key]);
      }
      const response = await ApiService.UPDATE_USER(formData);

      userDetail = response["result"];
      updateUserDetail(userDetail);
      setLoading(false);
      setSaveChanges(true);
    } catch (error) {
      setLoading(false);

      notifier.error(getErrorString(error));
    }
  };

  let year = new Date().getFullYear();

  const check = () => {
    if (amount < 1800) {
      notifier.error(t("notifier.error.toast6"));
      return;
    } else {
      updateProfile();
    }
  };
  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          props["backdropOff"]
            ? props.handleClose(true)
            : props.handleClose(false);
        }}
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,

            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1} sx={{ backgroundColor: "#1E1E1E" }}>
          <Stack sx={{ borderBottom: "2px dashed #4D4D4D", padding: "16px" }}>
            <Typography className="fs-17">{t("dobPopup.header")}</Typography>
          </Stack>
          <Stack sx={{ padding: "16px" }}>
            <Typography className="fs-14">{t("dobPopup.subHeader")}</Typography>
            <Formik
              innerRef={formRef}
              validationSchema={schema}
              onSubmit={(values) => {
                updateProfile(values);
              }}
              initialValues={{
                birthYear: userDetail["birthYear"]
                  ? userDetail["birthYear"]
                  : "Nooo",
              }}
            >
              {({ handleSubmit, values, setFieldValue }) => (
                <Stack onSubmit={handleSubmit}>
                  <DialogContent sx={{ padding: 0 }}>
                    <OutlinedInput
                      type="number"
                      sx={{ width: "100%", height: "50px !important" }}
                      autoFocus
                      margin="dense"
                      id="name"
                      placeholder={t("signUp.placeholder4")}
                      value={values.birthYear}
                      onChange={(e) => {
                        if (e.target.value > year) {
                          notifier.error(t("notifier.error.toast6"));
                        } else {
                          setAmount(e.target.value);
                          setFieldValue("birthYear", e.target.value);
                        }
                      }}
                      onKeyDown={(e) =>
                        ["e", "E", "+", "-"].includes(e.key) &&
                        e.preventDefault()
                      }
                    />
                  </DialogContent>
                </Stack>
              )}
            </Formik>
            <Stack>
              <Typography
                className="fs-14"
                sx={{
                  color: "#828282",
                  textAlign: "center",
                  marginTop: "18px",
                }}
              >
                {t("dobPopup.text1")}
                <br /> {t("dobPopup.text2")} <br />
                {t("dobPopup.text3")}
              </Typography>
            </Stack>
            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="default"
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleClose(false);
                }}
              >
                {t("cancel")}
              </Button>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  check();
                }}
                disabled={!amount}
              >
                {t("submit")}
              </Button>
            </DialogActions>
          </Stack>
        </Stack>
      </Dialog>
      {saveChange ? (
        <SuccessPopup
          open={saveChange}
          handleClose={(e) => {
            window.location.reload();
            // setSaveChanges(false), history.goBack();
          }}
        />
      ) : null}
      {loading ? <Loader /> : null}
    </div>
  );
}
